import snakecase from 'lodash.snakecase';

import {transformQueryParams, filterUnfinishedDateParams} from '~utils/object';

import api, {apiSetup} from '../api';

apiSetup();

export const formatProjectResponse = data =>
    data.map(item => ({
        ...item,
        id: item.code,
        // status: statusChoices.filter(c => c.id === item.status)[0].name
        // infrastructure: infraestructureChoices.filter(c => c.id === item.infrastructure)[0].name
    }));

export const parseResponse = rawResponse => ({
    data: rawResponse.data.page,
    total: rawResponse.data.count
});

export default {
    getList: (resource, params) => {
        const sharedParams = {
            ...filterUnfinishedDateParams(transformQueryParams(params.filter)),
            page: params.pagination.page,
            limit: params.pagination.perPage
        };
        let getParams = {
            ...sharedParams,
            [`order[${snakecase(params.sort.field)}]`]: params.sort.order
        };
        getParams = {
            ...sharedParams,
            sort: params.sort.field,
            order: params.sort.order
        };
        if (resource === 'actions') {
            return api.get('/actions/', getParams).then(response => {
                if (response.ok) {
                    response.data.page = formatProjectResponse(response.data.page);
                    const parsedResponse = parseResponse(response);
                    return parsedResponse;
                }
                throw response;
            });
        }
        else if (resource === 'territories') {
            return api.get('/territories/', getParams).then(response => {
                if (response.ok) {
                    const parsedResponse = parseResponse(response);
                    return parsedResponse;
                }
                throw response;
            });
        }
        return Promise.reject('Not implemented');
    },
    getOne:     (resource, params) => Promise.reject('Not implemented'),
    getMany:    (resource, params) => Promise.reject('Not implemented'),
    getManyReference: (resource, params) => Promise.reject('Not implemented'),
    create:     (resource, params) => Promise.reject('Not implemented'),
    update:     (resource, params) => Promise.reject('Not implemented'),
    updateMany: (resource, params) => Promise.reject('Not implemented'),
    delete:     (resource, params) => Promise.reject('Not implemented'),
    deleteMany: (resource, params) => Promise.reject('Not implemented'),
};
